export default __webpack_public_path__ + "static/media/ikara-logo-footer.4e743cbf.png";